<img [src]="'/assets/client-ip-board/house-icon-large.png'" />
<div class="upper-space selector-content">
  <div class="intend-select-any-checkbox">
    <mat-checkbox [(ngModel)]="intendSelectAny"
      >Ik wens afkortingen te plaatsen op mijn bord</mat-checkbox
    >
  </div>
  <ng-container *ngIf="intendSelectAny">
    <div class="smaller-upper-space checkbox-container">
      <mat-checkbox
        *ngFor="let state of abbreviationSelectStates; let last = last"
        [ngClass]="!last ? 'no-label-bottom-margin' : ''"
        [(ngModel)]="state.selected"
        >{{
          state.abbreviation.abbreviation
            | joiner: ' - ':state.abbreviation.label
        }}</mat-checkbox
      >
    </div>
  </ng-container>
</div>
<div class="upper-space button-container">
  <button mat-button class="close-button" (click)="close()">
    Sluiten
  </button>
  <button mat-button class="save-button" (click)="saveSelection()">
    Opslaan
  </button>
</div>
